import { useState, useEffect } from 'react';

/**
 * @internal
 * Hook used for getting the active element.
 * @returns the currently focused element.
 */
export const useActiveElement = (): HTMLElement => {
  const [active, setActive] = useState(document.activeElement as HTMLElement);

  const handleFocusIn = (e: FocusEvent) => {
    setActive(document.activeElement as HTMLElement);
  };

  useEffect(() => {
    document.addEventListener('focusin', handleFocusIn);
    return () => {
      document.removeEventListener('focusin', handleFocusIn);
    };
  }, []);

  return active;
};
